import React, { useEffect } from "react";
import { Project } from "../../../../project/types/project.type";

import TeamCreateUpdateFormView from "./TeamCreateUpdateFormView/TeamCreateUpdateFormView";
import {
  CheckTeamInputResult,
  validationInputCreationTeam,
} from "../../../../project/utils/validatorInput";
import {
  Team,
  TEAM_OPTIONS,
  TeamOption,
  TeamPatch,
  TeamRoles,
} from "../../../types/team.types";
import { useTeam } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import teamAPI from "../../../services/teamAPI";
import useUserAuth from "../../../../auth/hook/useUserAuth";
import { chechUserIsAuthorizedTo } from "../../../utils/team.utils";
import { User } from "../../../../user/types/user.types";

export interface CreateTeamFormPrensenterProps {
  idTeamToUpdate?: string;
  initData?: {
    teamName?: string;
    teamDescription?: string;
    project?: Project | null;
    membersList?: User[];
    managerListId?: string[];
    role?: TeamRoles | null;
  } | null;

  callbackUpdate?: (result: { result?: any; error?: any }) => void;
}
export default function CreateTeamFormPrensenter({
  idTeamToUpdate,
  initData,
  callbackUpdate,
}: CreateTeamFormPrensenterProps) {


  const [teamName, setTeamName] = React.useState<string>(
    initData?.teamName || ""
  );
  const [teamDescription, setTeamDescription] = React.useState<string>(
    initData?.teamDescription || ""
  );
  const [project, setProject] = React.useState<Project | null>(
    initData?.project || null
  );
  const [membersList, setMembersList] = React.useState<User[]>(
    initData?.membersList || []
  );
  const [manager, setManager] = React.useState<string[] | null>(
    initData?.managerListId || null
  );
  const [teamRole, setTeamRole] = React.useState<TeamRoles>(
    initData?.role || "OTHER"
  );

  const [teamOptionsList, setTeamOptionsList] = React.useState<TeamOption[]>(TEAM_OPTIONS);

  const [isLoadingTeamOption, setIsLoadingTeamOption] = React.useState<boolean>(false);

  const [validationInput, setValidationInput] =
    React.useState<CheckTeamInputResult | null>(null);

  const { createNewTeam, updateTeam, deleteTeam } = useTeam();
  const navigate = useNavigate();

  const checkInput = () => {
    const team: TeamPatch = {
      team_name: teamName,
      team_description: teamDescription,
      team_project: project?.project_id || "",
      team_users: membersList.map((employee) => employee.user_id),
      team_manager: (teamRole !== "COMPTA_ADMIN" && teamRole !== "TECH_SUPERVISOR") ? (manager ? [...manager] : []) : [],
      team_role: teamRole,
    };

    const checkResult = validationInputCreationTeam(team);
    setValidationInput(checkResult);
    if (checkResult.allFalse) {
      return team;
    }

    return null;
  };

  const callbackCreate = ({
    result,
    error,
  }: {
    result?: Team;
    error?: any;
  }) => {
    if (result && !idTeamToUpdate) {
      navigate("/teams/" + result.team_id, { replace: true });
    }
  };

  const callbackDelete = ({ result, error }: { result?: any; error?: any }) => {
    if (result) {
      navigate("/teams");
    }
  };
  const oncCallbackUpdate = ({
    result,
    error,
  }: {
    result?: any;
    error?: any;
  }) => {
    callbackUpdate && callbackUpdate({ result, error });
  };

  const submitForm = () => {
    const team = checkInput();

    console.log(team);

    if (team) {
      if (!idTeamToUpdate) {
        createNewTeam.run({ newTeam: team, callback: callbackCreate });
        return;
      } else {

        

        updateTeam.run({
          idTeam: idTeamToUpdate,
          teamUpdated: team,
          callback: oncCallbackUpdate,
        });
      }
    }
  };


  useEffect(() => {
    setIsLoadingTeamOption(true);
    Promise.all([
      teamAPI.fecthTeamAPIProtected({ role: "COMPTA_ADMIN" }),
      teamAPI.fecthTeamAPIProtected({ role: "TECH_SUPERVISOR" }),
    ])
      .then(([comptableResult, superviseurResult]) => {
        setIsLoadingTeamOption(false);

        if(comptableResult && comptableResult.data && comptableResult.data.data?.length && comptableResult.data.data?.length > 0&&
        idTeamToUpdate !== comptableResult.data.data[0].team_id)
        {

          editTeamOptionListRole({
            value: "COMPTA_ADMIN",
            label: "Comptable",
            disable: true,
            message: "Une équipe comptable existe déjà ("+comptableResult.data.data[0].team_name+")"
          })
        }

        if(superviseurResult && superviseurResult.data && superviseurResult.data.data?.length && superviseurResult.data.data?.length > 0&&
        idTeamToUpdate !== superviseurResult.data.data[0].team_id)
        {

          editTeamOptionListRole({
            value: "TECH_SUPERVISOR",
            label: "Superviseur Technique",
            disable: true,
            message: "Une équipe Superviseur Technique existe déjà ("+superviseurResult.data.data[0].team_name+")"
          })
        }
      }).catch(((error) => {
        setIsLoadingTeamOption(false);
      }));
      // eslint-disable-next-line
  }, []);

  const onDeleteTeam = () => {
    if (idTeamToUpdate) {
      deleteTeam.run({ idTeam: idTeamToUpdate, callback: callbackDelete });
    }
  };

  const editTeamOptionListRole = (option: TeamOption) => {
    setTeamOptionsList((currentList) =>
      currentList.map((optionItem) => {
        if (optionItem.value === option.value) {
          return option;
        }
        return optionItem;
      })
    );
  };

  const {userInfo} = useUserAuth()

  if (!userInfo ||
    chechUserIsAuthorizedTo((idTeamToUpdate ? 'modify' : 'create'), userInfo?.user_role) === false
  ){
    return (<p>Désolé, vous n'êtes pas authorisé à {idTeamToUpdate ? "modifer cette équipe": "créer une équipe" }.</p>)
  }


  return (
    <TeamCreateUpdateFormView
      teamName={teamName}
      setTeamName={setTeamName}
      teamDescription={teamDescription}
      setTeamDescription={setTeamDescription}
      project={project}
      setProject={setProject}
      membersList={membersList}
      setMembersList={setMembersList}
      manager={manager}
      setManager={setManager}
      onSubmitForm={submitForm}
      employeeProhibitedListForManager={membersList?.map((employee) => ({
        id: employee.user_id,
        description: "Membre de cette équipe",
      }))}
      employeeProhibitedListForMembers={
        manager
          ? manager.map((managerId) => ({
              id: managerId,
              description: "Manager de cette équipe",
            }))
          : []
      }
      isErrorName={validationInput?.isErrorName}
      isErrorDescription={validationInput?.isErrorDescription}
      isErrorProject={validationInput?.isErrorProject}
      isErrorMembers={validationInput?.isErrorMembers}
      isErrorManager={validationInput?.isErrorManager}
      isLoadingSending={createNewTeam.isLoading}
      submitBtnLabel={
        idTeamToUpdate ? "Enregistrer les modifications" : "Créer l'équipe"
      }
      onDeleteTeam={idTeamToUpdate ? onDeleteTeam : undefined}
      teamRole={teamRole}
      setTeamRole={setTeamRole}
      teamRoleOptions={teamOptionsList}
      isLoadingTeamOption={isLoadingTeamOption}
    />
  );
}
